Apt.fn.make('modal', {
	/**
	 * Open a new modal
	 *
	 * @param {Object} options
	 */
	open: function(options) {
		var scope = this,
			conf = $.extend({
				close: true,
				mask: true
			}, options);

		scope.conf = conf;

		if (! scope.$modal) {
			scope.$modal = $('<div class="modal"/>');
			scope.$inner = $('<div class="modal__inner"/>');
			scope.$mask = $('<div class="modal-mask"/>');
			scope.$close = $('<div class="modal__close"/>');

			scope.$modal
				.append(scope.$inner)
				.append(scope.$close);

			$($._body)
				.append(scope.$modal)
				.append(scope.$mask);
		} else if (scope.visible) {
			clearTimeout(scope.autoHide);
			scope.hide();
		}

		if (conf.modalClass) {
			scope.$inner.addClass(conf.modalClass);
		}

		if (conf.mask) {
			scope.$mask.on('click.modal', function() {
				if ($.screen.size() > 1) {
					scope.close();
				}
			});

			scope.top = $.screen.size() === 1 ? $.scrollTop() : false;

			scope.$mask.addClass('-is-loading -is-visible ' + (conf.maskClass || ''));
		}

		if (conf.close) {
			scope.$close.on('click.modal', function() {
				scope.close();
			});

			$($._doc).on('keyup.modal', function(e) {
				if (e.keyCode === 27) {
					scope.close();
				}
			});

			scope.$close.addClass('-is-visible');
		}

		scope.load(conf);

		if (conf.autoHide) {
			scope.autoHide = setTimeout(
				scope.$close, 1000 * conf.autoHide
			);
		}
	},

	/**
	 * Load new content into an existing modal
	 *
	 * @param {Object} conf
	 */
	load: function(conf) {
		var scope = this,
			width = conf.width,
			height = conf.height;

		if (conf.url) {
			$.fetch.request({
				url: conf.url,
				post: conf.post || false,
				success: function(data) {
					scope.show(data, width, height);

					if (conf.success) {
						conf.success();
					}
				},
				error: function() {
					scope.hide(true);
				}
			});
		} else if (conf.img) {
			var img = new Image();

			img.onload = function() {
				scope.show(img, width || img.width, height || img.height);
			};

			img.src = conf.img;
		} else {
			scope.show(conf.content, width, height);
		}
	},

	/**
	 * Display a modal on the page
	 *
	 * @param {String} content
	 * @param {Number} width
	 * @param {Number} height
	 */
	show: function(content, width, height) {
		var scope = Apt.modal; // eslint-disable-line

		scope.visible = true;

		scope.$mask.removeClass('-is-loading')
			.addClass('-is-visible');

		scope.$inner
			.empty()
			.height(height || '');

		scope.$inner.append(content);

		$.exec(scope.conf.onShow);

		scope.$modal.addClass('-is-visible');

		$($._win).on('resize', function() {
			scope.resize();
		}, {
			init: true,
			namespace: 'modal'
		});

		scope.$modal.addClass('-is-loaded');

		var input = scope.$inner.find('input[autofocus]');

		scope.$inner.scrollTop(0);

		if (input.length) {
			input.first().focus();
		}
	},

	/**
	 * Resize modal container based on content height
	 */
	resize: function() {
		var scope = this;

		if (! scope.visible) {
			return;
		}

		var mobile = $.screen.size() === 1;

		scope.$inner.width(
			scope.conf.width ? (mobile ? '' : scope.conf.width) : ''
		);

		if (mobile) {
			scope.$modal.css('top', '48px');
			return;
		}

		// Check if we're on a product page
		if ($('body').hasClass('product-page')) {
			// Center the modal in the viewport for product pages
			scope.$modal.css({
				'top': '50%',
				'left': '50%',
				'transform': 'translate(-50%, -50%)'
			});
		} else {
			scope.$modal.css('top', Math.max(
				(($._win.innerHeight / 2) - (scope.$modal[0].scrollHeight / 2)), 0
			) + 'px');
		}
	},

	/**
	 * Close the displayed modal
	 */
	close: function() {
		var scope = this;

		if (! scope.visible) {
			return;
		}

		$.events.reset('modal');

		scope.autoHide = setTimeout(function() {
			scope.hide();
		}, 200);
	},

	/**
	 * Hide the displayed modal
	 *
	 * @param {Boolean} [force=false]
	 */
	hide: function(force) {
		var scope = this;

		if (! scope.visible && ! force) {
			return;
		}

		scope.visible = false;

		scope.$mask.removeClass('-is-visible');

		if ($.screen.size() === 1) {
			if (scope.top !== false) {
				$._win.scrollTo(0, scope.top);
			}
		} else {
			scope.$mask.on('transitionend', function() {
				scope.$mask.removeClass('-is-visible');
			}, {
				namespace: 'modal',
				once: true
			});
		}

		scope.$modal.add(scope.$close)
			.removeClass('-is-visible');

		$.exec(scope.conf.onHide);
	},

	/**
	 * Check model open state
	 *
	 * @returns {Boolean}
	 */
	opened: function() {
		return this.visible;
	}
});